import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'

export const selectAlert = createSelector(
  [(state: ApplicationState) => state.AlertStore],
  (alert) => alert
)
